import { useEffect, useState } from "react";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { AppShell } from "@/components/ui/app-shell";
import { Else, If } from "@/components/ui/conditional";
import { NameGate } from "@/features/settings";
import { settings } from "@/lib/settings";
import { recoverUnhashedPages, defaultPersistDeps } from "@/lib/page-persist";

export const rootRoute = createRootRoute({
  component: function Root() {
    const [named, setNamed] = useState(() => !!settings.getScannerName());

    useEffect(() => {
      void recoverUnhashedPages(defaultPersistDeps);
    }, []);

    return (
      <If condition={!named}>
        <AppShell>
          <NameGate onSaved={() => setNamed(true)} />
        </AppShell>
        <Else>
          <Outlet />
        </Else>
      </If>
    );
  },
});
